<form [formGroup]="validatorForm">
  <fieldset>
    <legend>Input Requirements *</legend>
    <div class="wrappers">
      <div class="wrapper flex flex-col justify-start items-start" *ngFor="let validator of requiredValidators">
        <div class="flex flex-row justify-start items-center" *ngIf="validator === 'IdentityValidator'">
          <mat-checkbox *ngIf="validator === 'IdentityValidator'"
                        [(ngModel)]="isValidatorChecked[validator]"
                        [disabled]="disabled"
                        formControlName="isIdentity">
            This is a identity field
          </mat-checkbox>
        </div>
        <div class="flex flex-row justify-start items-center" *ngIf="validator === 'MandatoryValidator'">
          <mat-checkbox *ngIf="validator === 'MandatoryValidator'"
                        [(ngModel)]="isValidatorChecked[validator]"
                        [disabled]="disabled"
                        formControlName="isMandatory">
            This is a mandatory field
          </mat-checkbox>
        </div>
        <div class="flex flex-row justify-start items-center" *ngIf="validator === 'MaximumValueValidator'">
          <mat-checkbox
            [(ngModel)]="isValidatorChecked[validator]"
            [disabled]="disabled"
            formControlName="isMinimumChecked">
            Users must provide a minimum number of characters
          </mat-checkbox>
          <mat-form-field appearance="outline" class="m-l-auto">
            <input matInput placeholder="Placeholder Id" name="minvalue" [(ngModel)]="validatorInputValue[validator]"
                   formControlName="MinimumValueValidator"/>
          </mat-form-field>
        </div>
        <div class="flex flex-row justify-between items-center" *ngIf="validator === 'MinimumValueValidator'">
          <mat-checkbox
            [(ngModel)]="isValidatorChecked[validator]"
            [disabled]="disabled"
            formControlName="isMaximumChecked">
            Users must provide a maximum number of characters
          </mat-checkbox>
          <mat-form-field appearance="outline" class="m-l-auto">
            <mat-label>Value</mat-label>
            <input [(ngModel)]="validatorInputValue[validator]" matInput placeholder="Placeholder" name="maxvalue"
                   formControlName="MaximumValueValidator">
          </mat-form-field>
        </div>
      </div>
    </div>
  </fieldset>
</form>

